import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import type { IPickMutation } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient, queryClient } from "../../clients";

import type { IMemberWorkingExperience } from "./routeType";
import { useGetAllMemberWorkingExperiences } from "./getAll";
import { useGetMemberWorkingExperience } from "./get";

const { getPath } = getApi("members.workingExperience.put");

type IExtractedRouteType =
  IMemberWorkingExperience["workingExperienceSingleUpdate"];

export type IPutMemberWorkingExperience = IPickMutation<IExtractedRouteType>;

const putMemberWorkingExperience: MutationFunction<
  IPutMemberWorkingExperience["response"],
  IPutMemberWorkingExperience["variables"]
> = ({ experienceId, ...data }) => {
  return axiosClient.put(getPath({ experienceId }), data);
};

export const usePutMemberWorkingExperience = createMutation({
  mutationFn: putMemberWorkingExperience,
  onSuccess: (_, { experienceId }) => {
    queryClient.invalidateQueries({
      queryKey: useGetAllMemberWorkingExperiences.getKey(),
    });
    queryClient.invalidateQueries({
      queryKey: useGetMemberWorkingExperience.getKey({ experienceId }),
    });
  },
});
